/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Resources } from '../models/Resources';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ResourcesService {

    /**
     * Delete Resource
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteResourceApiV1ResourcesIdDelete(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/V1/resources/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Resources
     * @returns Resources Successful Response
     * @throws ApiError
     */
    public static getResourcesApiV1ResourcesGet(): CancelablePromise<Array<Resources>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/V1/resources/',
        });
    }

}
